import React from 'react';
import createReactClass from 'create-react-class';
import _ from 'lodash';
import {string, bool, object} from 'prop-types';
import {Slider as CoreSlider} from 'wix-ui-core/slider';
import {st, classes, $skin} from './Slider.st.css';
import {mixins, santaTypesDefinitions, utils} from 'santa-components';

export class Slider extends React.Component {
  focus() {
    this.node.focus();
  }

  blur() {
    this.node.blur();
  }

  render() {

    const {
      previewState,
      componentViewMode,
      isMobileView,
      tooltipPosition,
      orientation,
      isDisabled,
      className,
      ...restOfProps
    } = this.props;
    const sliderClass = st(
      classes.root,
      {['preview-' + previewState]: true},
      className
    );
    const shouldAlwaysShowTooltip =
      componentViewMode === 'editor' && this.props.tooltipVisibility !== 'none';
    const overriddenProps = {
      tooltipVisibility: shouldAlwaysShowTooltip ?
        'always' :
        this.props.tooltipVisibility,
      tooltipPosition: isMobileView ? 'normal' : tooltipPosition,
      orientation: isMobileView ? 'horizontal' : orientation
    };
    const overriddenStyle = {
      width: this.props.style.width,
      height: this.props.style.height
    };

    return (
      <CoreSlider
        ref={node => (this.node = node)}
        {...restOfProps}
        {...overriddenProps}
        className={sliderClass}
        disabled={isDisabled}
        style={overriddenStyle}
        aria-label={'range'}
      />
    );
  }
}

Slider.displayName = 'Slider';
Slider.propTypes = {
  previewState: string,
  tooltipVisibility: string,
  componentViewMode: string,
  tooltipPosition: string,
  orientation: string,
  isMobileView: bool,
  isDisabled: bool,
  className: string,
  style: object
};
Slider.defaultProps = {
  style: {width: 0, height: 0}
};

const {skinBasedComp, runTimeCompData, inputFocusMixin} = mixins;

const getComponentSkins = () => ({
  'wixui.skins.Slider': $skin
});

/**
 * @class components.slider
 * @extends {core.skinBasedComp}
 */

export const santaSlider = createReactClass({
  displayName: 'Slider',

  mixins: [
    skinBasedComp(getComponentSkins()),
    runTimeCompData,
    inputFocusMixin
  ],

  propTypes: {
    structure: santaTypesDefinitions.Component.structure.isRequired,
    compProp: santaTypesDefinitions.Component.compProp.isRequired,
    compData: santaTypesDefinitions.Component.compData.isRequired,
    componentViewMode: santaTypesDefinitions.RenderFlags.componentViewMode,
    componentPreviewState:
      santaTypesDefinitions.RenderFlags.componentPreviewState,
    styleId: santaTypesDefinitions.Component.styleId,
    style: santaTypesDefinitions.Component.style,
    isMobileView: santaTypesDefinitions.isMobileView
  },

  statics: {
    compSpecificIsDomOnlyOverride: () => false,
    behaviors: _.clone(inputFocusMixin.INPUT_FOCUS_BEHAVIORS),
    getComponentSkins
  },

  getInitialState() {
    return {
      value: this.props.compData.value
    };
  },

  UNSAFE_componentWillReceiveProps(nextProps) { // eslint-disable-line
    this.setState({value: nextProps.compData.value});
  },

  handleChange(value) {
    const nextState = {value};
    this.setState(nextState);
    this.updateData(nextState);
    this.handleAction('change', nextState);
  },

  focus() {
    this.sliderRef.focus();
  },

  blur() {
    this.sliderRef.blur();
  },

  handleFocus() {
    this.handleAction('focus');
  },

  handleBlur() {
    this.handleAction('blur');
  },

  getSkinProperties() {
    const sliderProps = _.assign({}, this.props.compData, this.props.compProp, {
      styleId: this.props.styleId,
      className: this.props.styleId,
      style: this.props.style,
      onChange: this.handleChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      value: this.state.value,
      width: _.get(this.props.structure, 'layout.width', 0),
      height: _.get(this.props.structure, 'layout.height', 0),
      previewState: this.props.componentPreviewState,
      componentViewMode: this.props.componentViewMode,
      isMobileView: this.props.isMobileView,
      ref: sliderRef => {
        this.sliderRef = sliderRef;
      }
    });

    return {
      '': {
        children: [utils.createReactElement(Slider, sliderProps)]
      }
    };
  }
});
